import { Reducer } from 'redux'
import { CHECKLIST_DIALOG_ACTION_TYPES } from '../actions/ui'

const { CLOSE_CHECKLIST_DIALOG, OPEN_CHECKLIST_DIALOG } = CHECKLIST_DIALOG_ACTION_TYPES

export interface IUiReducerState {
  vins: {
    dialogOpen: boolean
  }
  checklist: {
    dialogOpen: boolean
  }
}

const defaultState: IUiReducerState = {
  vins: { dialogOpen: false },
  checklist: { dialogOpen: false },
}

const uiReducer: Reducer<IUiReducerState> = (state = defaultState, action) => {
  switch (action.type) {
    case OPEN_CHECKLIST_DIALOG:
      return {
        ...state,
        checklist: { dialogOpen: true },
      }
    case CLOSE_CHECKLIST_DIALOG:
      return {
        ...state,
        checklist: { dialogOpen: false },
      }
    default:
      return state
  }
}

export default uiReducer
